import { useMarkdown } from './useMarkdown';
import { Container } from './styled';
export function Markdown(props) {
    const { contents, writing = false } = props;
    const children = useMarkdown(typeof contents === 'string' ? contents : '');
    return <Container $writing={writing}>{children || contents}</Container>;
}
